import React from 'react';

import { ApIcon, colors } from '@alixpartners/ui-components';
import { Tooltip } from 'react-tippy';
import {
	Wrapper as BadgeWrapper,
	Text,
	StatusWrapper,
} from '../BudgetPerformance/Table/StatusCellRenderer/StatusCellRenderer.styles';
import {
	Wrapper,
	Item,
	Label,
	Value,
	StatusContainer,
	TooltipContent,
	TooltipIcon,
} from './HeaderSummary.styles';

export const HeaderSummary = ({ data, spendFormatter }) => {
	const { actual, forecast, status, original, variance } = data;
	const isOverrun = actual > forecast;

	return (
		<Wrapper>
			<Item>
				<Label>Original budget</Label>
				<Value>{spendFormatter(original)}</Value>
			</Item>
			<Item>
				<Label>Revised budget target</Label>
				<Value>{spendFormatter(forecast)}</Value>
			</Item>
			<Item>
				<Label>YTD actuals</Label>
				<Value>{spendFormatter(actual)}</Value>
			</Item>
			<Item>
				<Label>
					YTD savings target{' '}
					<TooltipIcon>
						<Tooltip
							position="top"
							animation="fade"
							theme="light"
							arrow
							trigger="click"
							html={
								<TooltipContent>
									<span>Definition:</span> Calculates savings target based on
									the original and revised budget <br />
									<span>Calculation:</span> Original Budget - Revised Budget =
									Savings Target
								</TooltipContent>
							}
							popperOptions={{
								modifiers: {
									preventOverflow: {
										enabled: true,
										boundariesElement: 'window',
									},
								},
							}}
						>
							<ApIcon
								iconName="outline_info"
								iconColor={colors.grey5}
								iconSize={15}
							/>
						</Tooltip>
					</TooltipIcon>
				</Label>
				<Value>{spendFormatter(original - forecast)}</Value>
			</Item>
			<Item>
				<Label>
					YTD savings realisation{' '}
					<TooltipIcon>
						<Tooltip
							position="top"
							animation="fade"
							arrow
							theme="light"
							trigger="click"
							html={
								<TooltipContent>
									<span>Definition:</span> Calculates savings based on the
									orginal budget vs actuals <br />
									<span>Calculation:</span> Original Budget - Actuals = Savings
									Realization
								</TooltipContent>
							}
							popperOptions={{
								modifiers: {
									preventOverflow: {
										enabled: true,
										boundariesElement: 'window',
									},
								},
							}}
						>
							<ApIcon
								iconName="outline_info"
								iconColor={colors.grey5}
								iconSize={15}
							/>
						</Tooltip>
					</TooltipIcon>
				</Label>
				<Value>{spendFormatter(original - actual)}</Value>
			</Item>
			<Item>
				<Label>
					YTD vs revised budget variance{' '}
					<TooltipIcon>
						<Tooltip
							position="top"
							animation="fade"
							arrow
							theme="light"
							trigger="click"
							html={
								<TooltipContent>
									<span>Definition:</span> Calculates savings varience from the
									revised budget savings target <br />
									<span>Calculation:</span> Revised Budget - Actuals = Savings
									Variance
								</TooltipContent>
							}
							popperOptions={{
								modifiers: {
									preventOverflow: {
										enabled: true,
										boundariesElement: 'window',
									},
								},
							}}
						>
							<ApIcon
								iconName="outline_info"
								iconColor={colors.grey5}
								iconSize={15}
							/>
						</Tooltip>
					</TooltipIcon>
				</Label>
				<Value>{spendFormatter(variance)}</Value>
				<StatusContainer>
					<BadgeWrapper>
						<StatusWrapper isOverrun={isOverrun} />
						<Text>{status}</Text>
					</BadgeWrapper>
				</StatusContainer>
			</Item>
		</Wrapper>
	);
};
